import React, { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import CMSLogin from './CMSLogin';
import CMSDashboard from './CMSDashboard';

const CMSApp = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        fontFamily: "'DM Mono', 'SF Mono', Menlo, Consolas, monospace",
        fontSize: '0.85rem',
        letterSpacing: '0.18em',
        textTransform: 'uppercase',
        opacity: 0.6,
      }}>
        Loading…
      </div>
    );
  }

  return user ? <CMSDashboard /> : <CMSLogin onLogin={() => setUser(getAuth().currentUser)} />;
};

export default CMSApp;

